module.exports = {
	"entries": {
		"add_entry": "Cobranças adicionais",
		"add_entry_message": "As cobranças inclusas serão contabilizadas no fechamento da próxima fatura.",
		"next_invoice_information": "Edite sua próxima fatura incluindo acréscimos ou descontos",
		"type": "Tipo",
		"description": "Descrição",
		"addition": "Acréscimo",
		"discount": "Desconto",
		"select_type": "Selecione o tipo de cobrança",
		"write_description": "Escreva uma breve descrição",
		"value": "Valor",
		"choose_entry_value": "Escolha um valor para sua cobrança adicional",
		"additional_entries_next_invoice": "Cobranças adicionais da próxima fatura",
		"placeholder": {
			"add_entry": "Ex.: Lançamento adicional"
		},
		"button": {
			"remove": "Excluir"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/entries/pt-BR.yml
// module id = 582
// module chunks = 1